<template>
  <div class="crud_module--rsr_stop_charger">
    <Popup ref="rsr_stop_popup">
      <div class="rsr_stop_popup">
        <div class="content" v-loading="loading">
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.connector_id") }}</label>
                <select v-model="input.connectorId">
                  <option
                    v-for="opt in connectors"
                    :value="opt.connector_id"
                    :key="opt.name"
                  >
                    {{getOptionValue(opt)}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.remark") }}</label>
                <textarea rows="10" v-model="input.remark"></textarea>
              </div>
            </div>
          </div>
          <div class="action-btn">
            <el-button type="primary" @click="stopCharger">{{
              $t("button.confirm")
            }}</el-button>
          </div>
        </div>
      </div>
    </Popup>
    <el-button  type="info" @click="rsrStopCharger">{{ $t("label.stop_charger") }}</el-button>
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {
    
  },
  async beforeMount() {
    this.key = this.$route.params.key;
    this.id = this.$route.params.id;
    this.connectors = this.data.cp_connectors;
  },
  methods: {
    getOptionValue(opt){
      if (opt?.name){
        return opt.name;
      }
      return opt.connector_id;
    },
    checkChargingStatusCode(){
      if(this.data?.charging_status_code?.charging_status_code == 'Charging' || this.data?.charging_status_code?.charging_status_code == 'SuspendedEVSE' || this.data?.charging_status_code?.charging_status_code == 'SuspendedEV'){
        return true;
      }
      return false;
    },
    async rsrStopCharger() {
      this.connectors = this.data.cp_connectors;
      this.$refs.rsr_stop_popup.show();
    },
    async stopCharger() {
      let action = this.$t("label.stop_charger");
      let message = this.$t("message.confirm_start_charger", {action : action});
      let confirm = await this.$confirm(message, message, {
        confirmButtonText: action,
        cancelButtonText: "取消",
        type: "warning",
      });
      if (!confirm) return;
      await this.$axios.post(`/${this.key}/rsrStopCharger/${this.id}`, {
          ...this.input,
        }).then(res=>{
        if(res.data?.status == "success"){
          this.$message({
            message: this.$t("success"),
            type: 'success'
          });
        }
        else if(res.data?.status == "error"){
          this.$message({
            message: this.$t(`error.${res.data?.errorCode}`),
            type: 'error'
          });
        }
        else {
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
        }
      }).catch(err=>{
        this.$message({
            message: this.$t("error.generic"),
            type: 'error'
        });
        return false;
      });
    },
  },
  data() {
    return {
      key: "",
      id:0,
      loading:false,
      connectors:[],
      input:{
        connectorId:0,
        remark:""
      },
    }
  }
}
</script>

<style lang="scss">
.crud_module--rsr_stop_charger{
  display:inline-block;
  margin-top: 10px;
  margin-left: 10px;
  .el-button--info{
    background-color: #909399;
  }
  
  .rsr_stop_popup {
    padding: 20px;
    height: auto;
    width: 200px;
    background: white;
    // overflow-y: auto;
    .action-btn {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      .export-btn {
        display: flex;
        justify-content: flex-end;
      }
    }
    .content {
      // padding: 20px;
      .detail {
        .item {
          font-size: 12px;
          margin-bottom: 10px;
          .data {
            width: 100%;
            display: flex;
          }
          .label {
            width: 130px;
            min-width: 130px;
            display: flex;
            align-items: center;
          }
          .data {
            .value {
              min-width: 200px;
              width: 100%;
              border: 1px solid gray;
              background-color: #e6e6e6 !important;
              padding: 3px 5px;
            }
          }
        }
      }
      .row {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        & > .field {
          flex-grow: 1;
          // width: 100%;
          max-width: 100%;
          & > :first-child {
            margin-right: 5px;
          }
          &:not(:first-child) {
            margin-left: 5px;
          }
        }

        .label-group,
        .control-group {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .label {
            // width: 150px;
            // min-width: 150px;
          }
          input:not([type="checkbox"]) {
            height: 30px;
            // width: 100%;
          }
          select {
            height: 30px;
            padding: 1px 2px;
          }
          textarea {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>